export const ACTIVE_ACCOUNT_STORAGE_KEY = 'rad_active_account_id'

export interface AccountMembership {
  account_id: string
}

export function loadActiveAccountId(storage: Storage = sessionStorage): string | null {
  return storage.getItem(ACTIVE_ACCOUNT_STORAGE_KEY)
}

export function persistActiveAccountId(accountId: string | null, storage: Storage = sessionStorage): void {
  if (accountId) {
    storage.setItem(ACTIVE_ACCOUNT_STORAGE_KEY, accountId)
    return
  }

  storage.removeItem(ACTIVE_ACCOUNT_STORAGE_KEY)
}

export function resolveActiveAccountId(
  memberships: AccountMembership[],
  preferredAccountId: string | null
): string | null {
  if (preferredAccountId && memberships.some((membership) => membership.account_id === preferredAccountId)) {
    return preferredAccountId
  }

  return memberships[0]?.account_id ?? null
}
